/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import props from './props.js';
import { renderTNodeJSX } from '../utils/render-tnode.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

var classPrefixMixins = getClassPrefixMixins("comment");
var _Comment = mixins(classPrefixMixins).extend({
  name: "TComment",
  props: props,
  methods: {
    renderReply: function renderReply() {
      var h = this.$createElement;
      var reply = renderTNodeJSX(this, "reply");
      return reply ? h("div", {
        "class": "".concat(this.componentName, "__reply")
      }, [reply]) : null;
    },
    renderActions: function renderActions() {
      var h = this.$createElement;
      var actions = renderTNodeJSX(this, "actions");
      return actions && actions.length ? h("ul", {
        "class": "".concat(this.componentName, "__actions")
      }, [actions.map(function (action, index) {
        return h("li", {
          "key": "action-".concat(index)
        }, [action]);
      })]) : null;
    },
    renderQuote: function renderQuote() {
      var h = this.$createElement;
      var quote = renderTNodeJSX(this, "quote");
      return quote ? h("div", {
        "class": "".concat(this.componentName, "__quote")
      }, [quote]) : null;
    },
    renderAuthorDatetime: function renderAuthorDatetime() {
      var h = this.$createElement;
      var author = renderTNodeJSX(this, "author");
      var datetime = renderTNodeJSX(this, "datetime");
      return (author || datetime) && h("div", {
        "class": "".concat(this.componentName, "__author")
      }, [author && h("span", {
        "class": "".concat(this.componentName, "__name")
      }, [author]), datetime && h("span", {
        "class": "".concat(this.componentName, "__time")
      }, [datetime])]);
    },
    renderContent: function renderContent() {
      var h = this.$createElement;
      return h("div", {
        "class": "".concat(this.componentName, "__content")
      }, [this.renderAuthorDatetime(), h("div", {
        "class": "".concat(this.componentName, "__detail")
      }, [renderTNodeJSX(this, "content")]), this.renderQuote(), this.renderActions()]);
    },
    renderAvatar: function renderAvatar() {
      var h = this.$createElement;
      var avatar = renderTNodeJSX(this, "avatar");
      return avatar ? h("div", {
        "class": "".concat(this.componentName, "__avatar")
      }, [typeof avatar === "string" ? h("img", {
        "attrs": {
          "src": avatar,
          "alt": ""
        },
        "class": "".concat(this.componentName, "__avatar-image")
      }) : avatar]) : null;
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": this.componentName
    }, [h("div", {
      "class": "".concat(this.componentName, "__inner")
    }, [this.renderAvatar(), this.renderContent()]), this.renderReply()]);
  }
});

export { _Comment as default };
//# sourceMappingURL=comment.js.map
